import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gen-router-outlet-wrapper',
  templateUrl: './router-outlet-wrapper.component.html',
  styleUrls: ['./router-outlet-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouterOutletWrapperComponent {

  constructor() { }

}
